const getTextFromHtml = (html: string | undefined) => {
  if (!html) return null;

  return html.replace(/<[^>]*>/g, '');
};

export default getTextFromHtml;
